import { IIsString } from "./__types__";

/**
 *
 * @param {string} data provided value
 * @returns {boolean} is value string
 */
export const isString: IIsString = (data: any): boolean =>
  Boolean(typeof data === "string");
